import { EProviderFeatures, TypesenseProvider } from "../typesense-provider";

class MathcingSearchProfile extends TypesenseProvider<any> {
  constructor() {
    super(`/collections`, [EProviderFeatures.GET, EProviderFeatures.LIST]);
  }

  public async search(filters: any) {
    const url = super.buildEndPointUrl(
      {
        q: filters.query,
        query_by: "name,countries,sectors,regions",
        filter_by: filters.filter,
        sort_by: filters.sort_by,
        page: filters.page ?? 1,
        per_page: 30,
      },
      `companies/documents/search`,
    );

    const request = this.httpClient.get(url);
    const { data } = await this.wrapRequest(request);
    return data;
  }

  public async facets(filters: any) {
    const request = this.httpClient.get(
      super.buildEndPointUrl(
        {
          // q: "*",
          // query_by: "*",
          // facet_by: "*",
          q: filters.query || "*",
          query_by: "*",
          facet_by: "*",
          // filter_by: filters.filter || "[sectors]",
        },
        `companies/documents/search`,
      ),
      {},
    );

    const result = await this.wrapRequest(request);
    return result.data.facet_counts;
  }
}

export const matchingSearchProvider = new MathcingSearchProfile();
